import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isDashboardEditable } from 'src/app/dashboards/dashboard-helpers/helpers';
import { dashboard } from 'src/app/models';
import { getUserInfoState, State } from '../../state';

@Component({
    selector: 'dashboard-access-icon',
    templateUrl: 'dashboard-access-icon.component.html',
    styleUrls: ['./dashboard-access-icon.component.scss'],
    standalone: false
})
export class DashboardAccessIconComponent implements OnInit, OnDestroy {
  @Input() dashboard: dashboard;
  isUserRootAccess: boolean;
  isUserPartner: boolean;
  isUserAllowedToEditOtherUsersDashboards: boolean;
  isReadOnly: boolean;
  userInfo$: Observable<any>;
  private ngUnsubscribe = new Subject<void>();

  constructor(private store: Store<State>,) {
    this.userInfo$ = this.store.select(getUserInfoState);
    this.userInfo$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(info => {
      this.isUserRootAccess = info?.userProperties?.isRoot;
      this.isUserPartner = info?.userProperties?.isPartner;
      this.isUserAllowedToEditOtherUsersDashboards = info?.userProperties?.allowToEditOtherUsersDashboards;
      this.isReadOnly = info?.userProperties?.isDashboardsReadOnly;
    });
   }

  ngOnInit(): void { }

  getPath() {
    let basePath, imageName = "Company";

    basePath = "assets/Img/Main/dashboard_access/";

    if (!this.dashboard.isPublic) {
      imageName = "Private";
    } else if (this.dashboard.userOwned) {
      imageName = "Company_Mine";
    } else if (isDashboardEditable(this.dashboard, this.isUserRootAccess, this.isUserPartner, this.isUserAllowedToEditOtherUsersDashboards,this.isReadOnly)) {
      imageName = "Company_Not_Mine_Editable";
    } else {
      imageName = "Company_Not_Mine_Not_Editable";
    }

    return basePath + imageName + ".svg";
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
